import React from 'react';
import { X } from 'react-feather';
import { Logo } from './Logo';
import { NavItem } from './NavItem';
export function MobileMenu({
  isOpen,
  onClose,
  activePage,
  onNavigate
}: {
  isOpen: boolean;
  onClose: () => void;
  activePage: string;
  onNavigate: (page: string) => void;
}) {
  return <div className={`fixed inset-0 bg-[#111111] z-50 transition-opacity duration-700 ease-in-out
        ${isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`} data-id="element-76">
      <div className="flex flex-col h-full" data-id="element-77">
        <div className="h-[80px] flex items-center justify-between px-8" data-id="element-78">
          <Logo onClick={() => {
          onNavigate('home');
          onClose();
        }} data-id="element-79" />
          <button onClick={onClose} className="p-2 rounded-full hover:bg-white text-white hover:text-[#111111] transition-all duration-300 transform hover:scale-105" aria-label="Close menu" data-id="element-80">
            <X size={24} strokeWidth={2} data-id="element-81" />
          </button>
        </div>
        <nav className="flex-1 py-12 px-8" data-id="element-82">
          <ul className="space-y-6 flex flex-col items-start" data-id="element-83">
            <li className="w-full" data-id="element-84">
              <NavItem label="The problem behind the problem" isActive={activePage === 'complexity'} onClick={() => {
              onNavigate('complexity');
              onClose();
            }} isMobile={true} data-id="element-85" />
            </li>
            <li className="w-full" data-id="element-86">
              <NavItem label="Turning research into decisions" isActive={activePage === 'research'} onClick={() => {
              onNavigate('research');
              onClose();
            }} isMobile={true} data-id="element-87" />
            </li>
            <li className="w-full" data-id="element-88">
              <NavItem label="Building systems that last" isActive={activePage === 'systems'} onClick={() => {
              onNavigate('systems');
              onClose();
            }} isMobile={true} data-id="element-89" />
            </li>
          </ul>
        </nav>
        <div className="px-8 py-6" data-id="element-90">
          <p className="text-fluid-sm text-[#7A8290]" data-id="element-91">© All rights reserved</p>
        </div>
      </div>
    </div>;
}